const INVALID_INTEGER_KEYS = [".", ",", "e", "E", "+", "-"];

export const integerQuantityMixin = {
    methods: {
        preventNonIntegerQuantity(event) {
            if (!INVALID_INTEGER_KEYS.includes(event.key)) return false;

            event.preventDefault();
            return true;
        },
        normalizeIntegerQuantity(value, emptyValue = 0) {
            if (value === null || value === undefined || value === "") {
                return emptyValue;
            }

            const match = String(value).match(/^\d+/);
            return match ? parseInt(match[0], 10) : emptyValue;
        },
        setIntegerQuantity(event, target, field) {
            const value = this.normalizeIntegerQuantity(
                event.target.value,
                ""
            );

            event.target.value = value === "" ? "" : String(value);
            this.$set(target, field, value);

            return value;
        },
    },
};
